import * as riot from 'riot'

import {RiotPlugins, BusRiotPlugin, bus} from '@wendig/lib'

riot.install(BusRiotPlugin)
riot.install(RiotPlugins.setTitle)
riot.install(RiotPlugins.i18n)

export {riot, bus}
